var map = {
	"./arcos/logo.png": 35636,
	"./iprovinay/logo.png": 1131,
	"./juarez/logo.png": 72681,
	"./migob/logo.png": 86856,
	"./navojoa/logo.png": 75254,
	"./nayarit/logo.png": 75296,
	"./oaxaca/logo.png": 2691,
	"./repuve/logo.png": 71599,
	"./tlajomulco/logo.png": 10824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77497;